import { OperacoesWebAPI } from '../../utils/global';
import api from '../api'

export const municipioService = {
    getMunicipio: () => {
        return api.get(`${OperacoesWebAPI.Municipio}/getMunicipio`)
            .then((res) => res)
            .catch(err => err)
    }
}